<template>
    <div class="mainNew">
        <div class="topTitle">
            <el-page-header @back="goBack" content="开班补课">
            </el-page-header>
        </div>

        <div class="classRecord">
            <section>
                <el-form ref="form" :inline="true" size="mini" :model="form" @submit.native.prevent>
                    <el-form-item label="商品名称">
                        <el-input v-model="form.name" placeholder="请输入商品名称" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="search">查询</el-button>
                    </el-form-item>
                </el-form>
                <div>
                    <el-table highlight-current-row :data="tableData" style="width: 100%"
                        :header-cell-style="{ background: '#f5f7fa' }" @cell-click="cellClick" height="calc(100vh - 275px)">
                        <el-table-column prop="name" label="名称">
                        </el-table-column>
                        <el-table-column prop="missStuNum" label="待补课人数">
                        </el-table-column>
                    </el-table>
                </div>
                <div style="overflow: hidden;margin-top:20px;padding: 10px;">

                    <div style="float:right">
                        <el-button type="primary" size="small" @click="goNext">下一步</el-button>
                    </div>

                </div>
            </section>
        </div>

    </div>
</template>
  
<script>
import {
    getXmGoodsListForOpenClassOfMiss,
} from "@/api/educational";

export default {
    data() {
        return {
            xm_goods_id: '',
            form: {},
            tableData: []
        };
    },
    mounted() {
        if (
            this.$store.state.user.selected_schools.length == 0 ||
            this.$store.state.user.selected_schools.length > 1
        ) {
            this.$message.warning("请选择1个目标校区");
            this.$router.push({
                name: "classRecord",
            });
        } else {
            this.getXmGoodsListForOpenClassOfMiss()

        }


    },
    methods: {
        goNext() {
            if (this.xm_goods_id != '') {
                this.$router.push({
                    name: "newClassStu",
                    query: {
                        id: this.xm_goods_id
                    }
                });
            } else {
                this.$message.warning('请选择商品')
            }

        },
        cellClick(val) {
            console.log(val, 789456);
            this.xm_goods_id = val.id
        },
        search() {
            this.getXmGoodsListForOpenClassOfMiss()
        },
        getXmGoodsListForOpenClassOfMiss() {
            getXmGoodsListForOpenClassOfMiss({
                campusIds: JSON.stringify(this.$store.state.user.selected_schools),
                name: this.form.name
            }).then((res) => {
                console.log(res);
                this.tableData = res.xmGoodsList
            })
        },
        goBack() {
            this.$router.push({
                name: "classRecord",
                query: {
                    active: this.$route.query.active
                }
            });
        }
    }
};
</script>
  
<style lang="scss" scoped>
.mainNew {
    height: 100%;
}

.topTitle {
    height: 60px;
    background: #fff;
    margin: 10px;
    padding: 20px;
    border-radius: 5px;
    box-sizing: border-box;
    font-size: 14px;

    span {
        color: rgba(0, 0, 0, 0.45);
    }
}

.classRecord {
    min-height: calc(100% - 30px);
    background-color: #fff;
    margin: 10px;
    border-radius: 5px;

    section {
        padding-top: 10px;
        padding-left: 20px;
        padding-right: 20px;
        padding-bottom: 20px;
    }

    .el-dropdown-link {
        cursor: pointer;
        color: #409eff;
        font-size: 12px;
        padding-right: 5px;
        padding-left: 10px;
    }

    .el-icon-arrow-down {
        font-size: 12px;
    }
}

.table-style {}

.stu {
    width: 100%;
    height: 40px;
    background: rgba(51, 126, 245, 0.5);
    border: 2px solid rgb(51, 126, 245);
    border-radius: 5px;
    margin-top: 20px;
    line-height: 40px;
    box-sizing: border-box;
    padding-left: 10px;
}

.stu span {
    margin-right: 10px;
}

/deep/ .el-icon-info:before {
    color: rgb(51, 126, 245);
    margin-right: 10px;
}
</style>
  